import { createAction } from "redux-actions"

import {
  SET,
  REQUEST_CREATE,
  RECEIVE_CREATE,
  REQUEST_UPDATE,
  RECEIVE_UPDATE,
  REQUEST_DELETE,
  RECEIVE_DELETE,
  REQUEST_IMPORT,
  RECEIVE_IMPORT
} from "./constants"

export const set = createAction(SET)
export const requestCreate = createAction(REQUEST_CREATE)
export const receiveCreate = createAction(RECEIVE_CREATE)
export const requestUpdate = createAction(REQUEST_UPDATE)
export const receiveUpdate = createAction(RECEIVE_UPDATE)
export const requestDelete = createAction(REQUEST_DELETE)
export const receiveDelete = createAction(RECEIVE_DELETE)
export const requestImport = createAction(REQUEST_IMPORT)
export const receiveImport = createAction(RECEIVE_IMPORT)
